export default __webpack_public_path__ + "static/media/beeftrader-background-image-dark.7af4aaa7.jpg";